<template>
<AppSidebar />
<div class="wrapper d-flex flex-column min-vh-100">
	<AppHeader />
	<div class="body flex-grow-1 pb-5">
		<CContainer lg>
			<!-- meta.keep_alive 페이지(데이터 인사이트)는 인스턴스를 살려 둔다 —
			다른 페이지로 나갔다 뒤로가기로 돌아와도 재조회 없이 이동 전 화면 그대로다.
			나머지 페이지는 지금처럼 매번 새로 마운트한다. -->
			<router-view v-slot="{Component, route}">
				<KeepAlive>
					<component :is="Component" v-if="route.meta.keep_alive" />
				</KeepAlive>
				<component :is="Component" v-if="!route.meta.keep_alive" />
			</router-view>
		</CContainer>
	</div>
	<AppFooter />
</div>
</template>
<script setup>
import{ useStore }from"vuex";
import{ CContainer }from"@coreui/vue";
import AppHeader from"@/components/AppHeader.vue";
import AppFooter from"@/components/AppFooter.vue";
import AppSidebar from"@/components/AppSidebar.vue";
import Category from "@/api/common/category";
const store = useStore();
Category.getProducer().then(( response )=>{
	store.commit("userInfoInsert", response.data.data);
});
</script>
<style scope lang="sass">
.wrapper
	background-color: rgb(235, 237, 239)
</style>